import { BaseQuestionPreview } from './base-question-preview.component';
import styled from 'styled-components';
import { styleVariables } from '@lib/common';
import { TextOptionInput } from '@lib/common';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var CorrectAnswerContainer = styled.div.withConfig({
  displayName: "fill-in-blank-question-previewcomponent__CorrectAnswerContainer",
  componentId: "sc-hezbka-0"
})(["color:", ";"], styleVariables.colors.gray11);
var CorrectAnswerNumber = styled.span.withConfig({
  displayName: "fill-in-blank-question-previewcomponent__CorrectAnswerNumber",
  componentId: "sc-hezbka-1"
})(["margin-right:8px;&:nth-child(2){width:85%;}&:nth-child(3){width:10%;display:flex;justify-content:flex-end;}"]);
var AnswerContainer = styled.div.withConfig({
  displayName: "fill-in-blank-question-previewcomponent__AnswerContainer",
  componentId: "sc-hezbka-2"
})(["display:flex;align-items:center;margin-top:8px;"]);
export var FillInBlankQuestionPreview = function FillInBlankQuestionPreview(props) {
  var question = props.question,
      questionIndex = props.index,
      previewMode = props.previewMode,
      onSaveReviewEditQuestion = props.onSaveReviewEditQuestion,
      sectionIndexSelected = props.sectionIndexSelected,
      answerValues = props.answerValues,
      disabled = props.disabled,
      active = props.active;
  return /*#__PURE__*/_jsx(BaseQuestionPreview, {
    question: question,
    index: questionIndex,
    previewMode: previewMode,
    active: active,
    children: question.answers.map(function (answer, index) {
      var correctAnswers = question.correctAnswers && question.correctAnswers.find(function (c) {
        return c.answerId.toString() === answer.id.toString();
      });
      var answerValueArray = answerValues && answerValues.filter(function (_ref) {
        var answerBlankId = _ref.answerBlankId;
        return answerBlankId === answer.id.toString();
      });
      var answerValue = answerValueArray && answerValueArray[answerValueArray.length - 1].value.text;
      return /*#__PURE__*/_jsxs(CorrectAnswerContainer, {
        children: [!previewMode && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs(CorrectAnswerNumber, {
            children: ["(", index + 1, ")"]
          }), answer.description]
        }), previewMode && answerValue && /*#__PURE__*/_jsxs(AnswerContainer, {
          children: [/*#__PURE__*/_jsxs(CorrectAnswerNumber, {
            children: ["(", index + 1, ")"]
          }), /*#__PURE__*/_jsx(CorrectAnswerNumber, {
            children: /*#__PURE__*/_jsx(TextOptionInput, {
              isHiddenDelete: true,
              defaultValue: answerValue,
              onChange: function onChange(e) {
                onSaveReviewEditQuestion(sectionIndexSelected, questionIndex, answer.id.toString(), e.target.value);
              },
              hasImage: false,
              onShowingUploadImageModal: function onShowingUploadImageModal() {
                throw new Error('Function not implemented.');
              }
            })
          }), correctAnswers && /*#__PURE__*/_jsxs(CorrectAnswerNumber, {
            children: [correctAnswers.score, " \u0111i\u1EC3m"]
          })]
        }), previewMode && !answerValue && /*#__PURE__*/_jsxs(AnswerContainer, {
          children: [/*#__PURE__*/_jsxs(CorrectAnswerNumber, {
            children: ["(", index + 1, ")"]
          }), /*#__PURE__*/_jsx(CorrectAnswerNumber, {
            children: /*#__PURE__*/_jsx(TextOptionInput, {
              disabled: disabled,
              isHiddenDelete: true,
              onChange: function onChange(e) {
                onSaveReviewEditQuestion(sectionIndexSelected, questionIndex, answer.id.toString(), e.target.value);
              },
              hasImage: false,
              onShowingUploadImageModal: function onShowingUploadImageModal() {
                throw new Error('Function not implemented.');
              }
            })
          }), correctAnswers && /*#__PURE__*/_jsxs(CorrectAnswerNumber, {
            children: [correctAnswers.score, " \u0111i\u1EC3m"]
          })]
        })]
      }, index);
    })
  });
};